import { render, staticRenderFns } from "./PayrollNew.vue?vue&type=template&id=9bec5b5a"
import script from "./PayrollNew.vue?vue&type=script&lang=js"
export * from "./PayrollNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports